/* KAPANDIKTAN SONRA DEFAULT HALE GETİRME */
var isStoreLocator = window.location.pathname.includes('store-locator') ||
                    window.location.pathname.includes('nearest-store');
var isMilanoPage = window.location.pathname.includes('/pages/milano') ||
                   window.location.pathname.includes('/pages/salone-del-mobile-lp');

if (!isStoreLocator && !isMilanoPage) {
    // Sadece mağaza bulucu sayfası değilse çalıştır
    
    let languageModal = document.getElementById('cilek-localeswitcher');
    let closeModalBtn = document.getElementById('close-language-btn')
    closeModalBtn.onclick = function(event) {
        languageModal.style.display = "none";
    }

    document.querySelector('#close-language-btn').addEventListener('click', () => {
        console.log( document.querySelector('#HeaderWrapper').classList)
        document.querySelector('#HeaderWrapper').classList.add('default-top-not-fixed'),
        document.querySelector('#SiteHeader').classList.add('default-top-not-fixed');
        if(bodyClassList.includes("template-page")){
            document.getElementById("HeaderWrapper").style.marginTop = "0" 
        }

        if(bodyClassList.includes("template-collection")){
            document.getElementById("HeaderWrapper").style.marginTop = "0" 
        }

        if(bodyClassList.includes("template-product")){ 
            document.getElementById("HeaderWrapper").style.marginTop = "0" 
        }
    });

    var bodyClassList = [...document.body.classList];
    if(bodyClassList.includes("template-index")){
        document.getElementById("HeaderWrapper").style.marginTop = "0"
    }

    /* LOCAL STORAGE
    $(document).ready(function(){
        if (window.localStorage.getItem('accept_cookies')) {
           $('#cilek-localeswitcher').remove();
           document.getElementById("HeaderWrapper").style.marginTop = "0";
           document.querySelector('#HeaderWrapper').classList.add('default-top-not-fixed');
           document.querySelector('#SiteHeader').classList.add('default-top-not-fixed');
        }

        $("#close-language-btn").click(function(){
            window.localStorage.setItem('accept_cookies', true);
            $('#cilek-localeswitcher').remove();
            document.getElementById("HeaderWrapper").style.marginTop = "0";
            document.querySelector('#HeaderWrapper').classList.add('default-top-not-fixed');
            document.querySelector('#SiteHeader').classList.add('default-top-not-fixed');
        }); 
    });
    */

    /* ÜLKE KODLARINA GÖRE GÖRÜNÜRLÜK */
    if (typeof get_country_code === 'function') {
        get_country_code().then((country_code) => {
          
          var country = country_code;
          var cnt = JSON.stringify(country);
          console.log(country);
          
          if (country == "US") {
               $("#usa").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("turkey").innerHTML = "United States";
               document.getElementById("global").innerHTML = "Another Country or Region";
               document.getElementById("ac-ls-continue").innerHTML = "Continue";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Select another country or region to view content specific to your location and shop online.";
               document.getElementById('language-select-id').getElementsByTagName('option')[18].selected = 'selected'
               $('#language-select-id option[value="1"],[value="2"],[value="3"],[value="4"],[value="5"],[value="6"],[value="7"],[value="8"],[value="9"],[value="10"],[value="11"],[value="12"],[value="13"],[value="14"],[value="15"],[value="16"],[value="17"],[value="20"]').remove();
          }
          
             if (country == "TR") {
               $("#turkey").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("turkey").innerHTML = "Türkiye";
               document.getElementById("global").innerHTML = "Başka Ülke veya Bölge";
               document.getElementById("ac-ls-continue").innerHTML = "Devam";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Bulunduğunuz yere özel içeriği görüntülemek ve çevrimiçi alışveriş yapmak için başka bir ülke veya bölge seçin.";
               document.getElementById('language-select-id').getElementsByTagName('option')[0].selected = 'selected'
               $('#language-select-id option[value="1"],[value="2"],[value="3"],[value="4"],[value="5"],[value="6"],[value="7"],[value="8"],[value="9"],[value="10"],[value="11"],[value="12"],[value="13"],[value="14"],[value="15"],[value="16"],[value="17"],[value="18"],[value="20"]').remove();
          }
          
             if (country == "DE") {   
               $("#germany").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("germany").innerHTML = "Deutschland";
               document.getElementById("global").innerHTML = "Ein anderes Land oder eine andere Region";
               document.getElementById("ac-ls-continue").innerHTML = "Fortsetzen";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Wählen Sie ein anderes Land oder eine andere Region aus, um für Ihren Standort spezifische Inhalte anzuzeigen und online einzukaufen.";
               document.getElementById('language-select-id').getElementsByTagName('option')[4].selected = 'selected'
               $('#language-select-id option[value="0"],[value="1"],[value="2"],[value="3"],[value="5"],[value="6"],[value="7"],[value="8"],[value="9"],[value="10"],[value="11"],[value="12"],[value="13"],[value="14"],[value="15"],[value="16"],[value="17"],[value="18"],[value="20"]').remove();
          }

             if (country == "RU") {   
               $("#russia").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("russia").innerHTML = "Россия ";
               document.getElementById("ac-ls-continue").innerHTML = "Продолжать";
               document.getElementById("global").innerHTML = "Другая страна или регион";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Выберите другую страну или регион, чтобы просмотреть контент, относящийся к вашему местоположению, и совершать покупки в Интернете.";
               document.getElementById('language-select-id').getElementsByTagName('option')[1].selected = 'selected'
               $('#language-select-id option[value="0"],[value="2"],[value="3"],[value="4"],[value="5"],[value="6"],[value="7"],[value="8"],[value="9"],[value="10"],[value="11"],[value="12"],[value="13"],[value="14"],[value="15"],[value="16"],[value="17"],[value="18"],[value="20"]').remove();
          }
          
              if (country == "KZ") {
               $("#kazakhstan").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("kazakhstan").innerHTML = "Казахстан ";
               document.getElementById("global").innerHTML = "Другая страна или регион";
               document.getElementById("ac-ls-continue").innerHTML = "Продолжать";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Выберите другую страну или регион, чтобы просмотреть контент, относящийся к вашему местоположению, и совершать покупки в Интернете.";
               document.getElementById('language-select-id').getElementsByTagName('option')[2].selected = 'selected'
               $('#language-select-id option[value="0"],[value="1"],[value="3"],[value="4"],[value="5"],[value="6"],[value="7"],[value="8"],[value="9"],[value="10"],[value="11"],[value="12"],[value="13"],[value="14"],[value="15"],[value="16"],[value="17"],[value="18"],[value="20"]').remove();
          }
          
          if (country == "BY") {
               $("#belarus").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("belarus").innerHTML = "Беларусь";
               document.getElementById("global").innerHTML = "Другая страна или регион";
               document.getElementById("ac-ls-continue").innerHTML = "Продолжать";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Выберите другую страну или регион, чтобы просмотреть контент, относящийся к вашему местоположению, и совершать покупки в Интернете.";
               document.getElementById('language-select-id').getElementsByTagName('option')[3].selected = 'selected'
          }
          
          if (country == "AT") {
               $("#austria").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("belarus").innerHTML = "Austria";
               document.getElementById("ac-ls-continue").innerHTML = "Fortsetzen";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Wählen Sie ein anderes Land oder eine andere Region aus, um für Ihren Standort spezifische Inhalte anzuzeigen und online einzukaufen.";
               document.getElementById('language-select-id').getElementsByTagName('option')[5].selected = 'selected'
          }
          
            if (country == "BE") {
               $("#belgium").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("belgium").innerHTML = "Belgium";
               document.getElementById("ac-ls-continue").innerHTML = "Fortsetzen";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Wählen Sie ein anderes Land oder eine andere Region aus, um für Ihren Standort spezifische Inhalte anzuzeigen und online einzukaufen.";
               document.getElementById('language-select-id').getElementsByTagName('option')[6].selected = 'selected'
          }
          
             if (country == "AR") {
               $("#argentina").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("argentina").innerHTML = "Argentina";
               document.getElementById("ac-ls-continue").innerHTML = "Seguir ";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Seleccione un país o región diferente para ver contenido y comprar en línea específico para su ubicación.";
               document.getElementById('language-select-id').getElementsByTagName('option')[9].selected = 'selected'
          }
          
             if (country == "MX") {
               $("#argentina").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("Mexico").innerHTML = "Mexico";
               document.getElementById("ac-ls-continue").innerHTML = "Seguir ";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Seleccione un país o región diferente para ver contenido y comprar en línea específico para su ubicación.";
               document.getElementById('language-select-id').getElementsByTagName('option')[10].selected = 'selected'
          }
          
              if (country == "BR") {
               $("#argentina").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("brazil").innerHTML = "Brazil";
               document.getElementById("ac-ls-continue").innerHTML = "Seguir ";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Seleccione un país o región diferente para ver contenido y comprar en línea específico para su ubicación.";
               document.getElementById('language-select-id').getElementsByTagName('option')[11].selected = 'selected'
          }
          
           if (country == "VE") {
               $("#argentina").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("venezuela").innerHTML = "Venezuela";
               document.getElementById("ac-ls-continue").innerHTML = "Seguir ";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Seleccione un país o región diferente para ver contenido y comprar en línea específico para su ubicación.";
               document.getElementById('language-select-id').getElementsByTagName('option')[12].selected = 'selected'
          }
          
             if (country == "CO") {
               $("#colombia").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("colombia").innerHTML = "Colombia";
               document.getElementById("ac-ls-continue").innerHTML = "Seguir ";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Seleccione un país o región diferente para ver contenido y comprar en línea específico para su ubicación.";
               document.getElementById('language-select-id').getElementsByTagName('option')[13].selected = 'selected'
          }
          
           if (country == "CL") {
               $("#chile").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("chile").innerHTML = "Chile";
               document.getElementById("ac-ls-continue").innerHTML = "Seguir ";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Seleccione un país o región diferente para ver contenido y comprar en línea específico para su ubicación.";
               document.getElementById('language-select-id').getElementsByTagName('option')[14].selected = 'selected'
          }
          
             if (country == "UY") {
               $("#uruguay").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("uruguay").innerHTML = "Uruguay";
               document.getElementById("ac-ls-continue").innerHTML = "Seguir ";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Seleccione un país o región diferente para ver contenido y comprar en línea específico para su ubicación.";
               document.getElementById('language-select-id').getElementsByTagName('option')[15].selected = 'selected'
          }
          
            if (country == "BO") {
               $("#bolivia").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("bolivia").innerHTML = "Bolivia";
               document.getElementById("ac-ls-continue").innerHTML = "Seguir ";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Seleccione un país o región diferente para ver contenido y comprar en línea específico para su ubicación.";
               document.getElementById('language-select-id').getElementsByTagName('option')[16].selected = 'selected'
          }
          
            if (country == "CR") {
               $("#bolivia").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("costarica").innerHTML = "Costa Rica";
               document.getElementById("ac-ls-continue").innerHTML = "Seguir ";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Seleccione un país o región diferente para ver contenido y comprar en línea específico para su ubicación.";
               document.getElementById('language-select-id').getElementsByTagName('option')[17].selected = 'selected'
          }
          
          if (country == "UA"){
               $("#ukraine").css("display", "block");
               $("#global").css("display", "block");
               document.getElementById("ukraine").innerHTML = "України ";
               document.getElementById("global").innerHTML = "Інша країна чи регіон";
               document.getElementById("ac-ls-continue").innerHTML = "Продовжуйте ";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Виберіть іншу країну або регіон, щоб переглянути вміст, характерний для вашого місцезнаходження, і робити покупки в Інтернеті.";
               document.getElementById('language-select-id').getElementsByTagName('option')[20].selected = 'selected'
               $('#language-select-id option[value="0"],[value="1"],[value="2"],[value="3"],[value="4"],[value="5"],[value="6"],[value="7"],[value="8"],[value="9"],[value="10"],[value="11"],[value="12"],[value="13"],[value="14"],[value="15"],[value="16"],[value="17"],[value="18"]').remove();
          }

          if (country != "US" && country != "TR" && country != "DE" && country != "RU" && country != "KZ" && country != "BY" && country != "AT" && country != "BE" && country != "AR" && country != "MX" && country != "BR" && country != "VE" && country != "CO" && country != "CL" && country != "UY" && country != "BO" && country != "CR" && country != "UA"){
               $("#global").css("display", "block");
               document.getElementById("global").innerHTML = "Another Country or Region";
               document.getElementById("ac-ls-continue").innerHTML = "Continue";
               document.getElementById("cilek-localeswitcher-text-id").innerHTML ="Select another country or region to view content specific to your location and shop online.";
               document.getElementById('language-select-id').getElementsByTagName('option')[19].selected = 'selected'
          }

        });
    }

    /* OPTION SELECT YÖNLENDİRME */
    var select = document.getElementById('language-select-id');

    document.getElementById("ac-ls-continue").onclick = function(){
        var value = select.value
        if (value == "0") {
            window.location.href = "https://cilek.com/";
        }
        else if (value == "1" || value == "2" || value == "3") {
            window.location.href = "https://cilekworld.com/ru";
        }
        else if (value == "4" || value == "5" || value == "6" || value == "7") {
            window.location.href = "https://cilekworld.com/de";
        }
        else if (value == "8" || value == "9" || value == "10" || value == "11" || value == "12" || value == "13" || value == "14" || value == "15" || value == "16" || value == "17") {
            window.location.href = "https://cilekworld.com/es";
        }
        else if (value == "18") {
            window.location.href = "https://www.cilekkidsroom.com/";
        }
        else if (value == "19") {
            window.location.href = "https://cilekworld.com/pages/choose-country-region";
        }
        else if (value == "20") {
            window.location.href = "https://cilekukraine.com/";
        }
    };

} else {
    console.log('Mağaza bulucu sayfası - ülke filtresi devre dışı');
}